var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('section', {
        staticClass: "advancedContainer"
    }, [
        _c('van-form', {
            ref: "formRef",
            on: {
                "submit": _setup.onSubmit
            }
        }, [
            _c('div', {
                class: _vm.$style.inputWrapper
            }, [
                _c('van-field', {
                    attrs: {
                        "type": "digit",
                        "name": "phone",
                        "maxlength": 10,
                        "border": false,
                        "label": "+52",
                        "autocomplete": _vm.autocomplete ? 'on' : 'off',
                        "label-class": _vm.$style.label,
                        "clearable": ""
                    },
                    on: {
                        "click": function($event) {
                            return _vm.$emit('input-click');
                        }
                    },
                    model: {
                        value: _setup.form.phone,
                        callback: function callback($$v) {
                            _vm.$set(_setup.form, "phone", $$v);
                        },
                        expression: "form.phone"
                    }
                })
            ], 1)
        ]),
        _c(_setup.CaptchaPopup, {
            ref: "captchaRef",
            attrs: {
                "phone-number": _setup.form.phone,
                "loading": _setup.captchaLoading,
                "sender": _setup.fetchCaptcha
            },
            on: {
                "finish": _setup.onCaptchaFinished
            },
            model: {
                value: _setup.visibleMap.captcha,
                callback: function callback($$v) {
                    _vm.$set(_setup.visibleMap, "captcha", $$v);
                },
                expression: "visibleMap.captcha"
            }
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
